import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../actions/constants';

const INITIAL_STATE = fromJS({
  attempting: false,
  token: null,
  user: null,
  error: null
});

const authenticationReducer = handleActions({
  [Types.AUTHENTICATION_ATTEMPT]: (state, action) => state.merge({ attempting: true, error: null }),
  [Types.AUTHENTICATION_SUCCESS]: (state, action) => state.merge({
    attempting: false,
    token: action.payload.token,
    user: action.payload.user
  }),
  [Types.AUTHENTICATION_FAILURE]: (state, action) => state.merge({ attempting: false, error: action.payload.error }),
  [Types.LOG_OUT]: (state, action) => INITIAL_STATE
}, INITIAL_STATE);


export default authenticationReducer;



// WEBPACK FOOTER //
// ./client/store/reducers/authenticationReducer.js